import { IonCol, IonItem, IonLabel, IonList, IonThumbnail } from "@ionic/react";
import React, { FC, useEffect, useState } from "react";
import { API_URL } from "../../../actions/settings";
import { default as incentives} from "../../../AE2/static/icons/recent_activity/Incentives Received.svg"
import { default as benchmark} from "../../../AE2/static/icons/recent_activity/New Benchmark Complete.svg"
import { default as score_trend} from "../../../AE2/static/icons/recent_activity/Scores Trending Downward.svg"
import { default as target_not_met} from "../../../AE2/static/icons/recent_activity/Target Not Met.svg"
import RecentActivityModal from "./RecentActivityModal";


async function getData(token: string) {
  return fetch(`${API_URL}/homepage/recent_activity`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: token,
    },
  }).then((res) => {
        if (res.ok) {
          return res.json();
        }
        else{
            console.log('error')
            res.json().then( err => {
                console.log(err)
                return null
            })

        }
      }).catch(error => {
        console.log(error)
        return null
      });
}

interface Item {
    id:string,
    title:string,
    icon:string,
    url:string,
    subtitle:string,
    name:string,
    uuid:string,
    type:string,
    modal: boolean

};

interface IProps {};

const items = [
    {
        'id':'score_trend_down',
        icon: score_trend,
        title:'Score Trending Downward',
        subtitle:'Buildings',
        url:'/',
        name:'',
        uuid:'',
        type:'',
        modal:true
    },
    {
        'id':'target_not_met',
        icon: target_not_met,
        title:'Target Not Met',
        subtitle:'Buildings',
        url:'/',
        name:'',
        uuid:'',
        type:'',
        modal:true
    },
    {
        'id':'benchmark_complete',
        icon: benchmark,
        title:'New Benchmark Completed',
        subtitle:'Buildings',
        url:'/',
        name:'',
        uuid:'',
        type:'',
        modal:false
    },
    {
        'id':'incentives',
        icon: incentives,
        title:'Incentives Received',
        subtitle:'Building Name',
        url:'/',
        name:'',
        uuid:'',
        type:'',
        modal:false
    },
    

]

const formatter = new Intl.DateTimeFormat('en-US', { 
  month: 'short', // Use 'short' for "Sep", 'numeric' for "9"
  day: 'numeric' 
});

const formatDate = (dateString: string) => {
  try {
    const date = new Date(dateString);
    return isNaN(date.getTime()) ? '' : formatter.format(date);
  } catch {
    return '';
  }
};



const RecentActivityCol:FC<IProps> = (props) => {
    const [itemData,setItemData] = useState<any>({})

    useEffect(() => {
        const handleData = async () => {
            const token = `Token ${(localStorage.getItem("token")||'').slice(1, -1)}`;            
            const res = await getData(token)            
            if(res){
                setItemData(res.data)
            }
            }
        handleData()
        },[])
    

    return <IonCol className="grey-border-2pt w-100 bg-white" style={{marginBottom:'1rem', borderRadius:'1rem', padding:'1rem', minHeight:'fit-content'}}>
                <div className="w-100 text-dark-blue font-helvetica font-med font-18pt" style={{borderBottom:'2pt solid #F1F3F6'}} > Recent Activity</div>
                <IonList>                    
                    {items.map((item:Item) => {
                        const title = <div style={{display:'flex'}}>
                                <IonThumbnail slot="start" style={{marginRight:'0.5rem', height:'100%'}}>
                                    <img src={item.icon} alt={`${item.id}-icon`} />
                                </IonThumbnail>
                                <h3 className="text-dark-blue">{item.title}</h3>
                            </div>

                        if(item.id in itemData){
                                                        
                            return <IonItem lines="none" key={item.id} style={{marginBottom:'1rem'}} href={item.modal ? undefined : `/?id=${itemData[item.id].uuid}&sec=${itemData[item.id].type}`}>                                 
                                    <IonThumbnail slot="start" style={{marginRight:'0.5rem', height:'100%'}}>
                                        <img src={item.icon} alt={`${item.id}-icon`} />
                                    </IonThumbnail>                       
                                    <IonLabel>
                                        <div className="font-helvetica font-bold font-13pt text-map-main">{item.title}</div>                            
                                        {item.modal ? 
                                        <div className="font-helvetica font-med font-12pt text-footer-blue"> {itemData[item.id].count} {item.subtitle}</div>
                                        :
                                        <div className="font-helvetica font-med font-12pt text-footer-blue"> {itemData[item.id].name} </div>}
                                    </IonLabel>
                                    { item.modal ? 
                                    <RecentActivityModal id={item.id} title={title}/> :
                                    <div slot="end"> {formatDate(itemData[item.id].date)}</div> }
                            </IonItem>
                            
                        }
                        return null
                    })
                    }
                </IonList>
            </IonCol>
};

export default RecentActivityCol;